import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { BeneficiaryContext } from '../../contexts/BeneficiaryContext';

export default function ViewGroup({ viewModal, closeModal, data }) {
  const { loadGroupBeneficiaries } = useContext(BeneficiaryContext);
  const [beneficiaries, setBeneficiaries] = useState(null);

  useEffect(() => {
    loadGroupBeneficiaries(data.id).then((res) => setBeneficiaries(res));
  }, []);

  return (
    <Modal style={customStyles} isOpen={viewModal}>
      <div className={'p-5'}>
        <div className={'mb-2 flex flex-row justify-between items-center'}>
          <h3 className={'font-bold text-xl'}>{data.group_name}</h3>
          <button onClick={closeModal}>
            <i className={'fas fa-times text-xl'} />
          </button>
        </div>
        <div>
          <table className={'table w-full'}>
            <thead>
              <tr>
                <th className={'font-semibold text-left'}>Full name</th>
                <th className={'font-semibold text-left'}>Phone</th>
              </tr>
            </thead>
            <tbody>
              {beneficiaries &&
                beneficiaries.map((item, index) => (
                  <tr key={index}>
                    <td>{item.full_name}</td>
                    <td>+{item.telephone_number}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
}
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 400,
  },
};
